import {NgModule, Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'removeQuotes'})

export class RemoveQuotesPipe implements PipeTransform {
    transform(value: string): string {
        let newValue = value.replace('"', '');
        return `${newValue}`;
    }

    // static forRoot() {
    //     return {
    //         ngModule: removeQuotes,
    //         providers: [],
    //     };
    // }
}


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/utils/remove-quotes.pipe.ts